module.exports = __webpack_public_path__ + "static/media/pickup_turquoise.c4d2854c.svg";